import React, {useMemo, useState} from 'react';
import {
  GestureHandlerRootView,
  ScrollView,
} from 'react-native-gesture-handler';
import {
  Portal,
  Modal,
  Card,
  Avatar,
  Button,
  List,
  Divider,
  Banner,
  ProgressBar,
  useTheme,
  Switch,
  Text,
  TextInput,
  Menu,
} from 'react-native-paper';
import {niceBytes} from '../../../api/util';
import {
  Image,
  ImageBackground,
  Platform,
  useWindowDimensions,
  View,
} from 'react-native';
import {AVPlaybackStatusSuccess, Video} from 'expo-av';
// Image
import {
  useConfirmFile,
  FileUploadProps,
} from '../../../hooks/useConfirmFile';
import {defaultVideoDuration} from '../../../api/encoder/util/genVideoFromImage';

export default function FileUpload(props: FileUploadProps) {
  const theme = useTheme();
  const {
    confirmFile,
    setVideoMeta,
    pickerFile,
    pickerFileMeta,
    mediaModalVisible,
    loading,
    videoMeta,
    fileType: type,
    isImageType,
    isVideoType,
    isEditorProject,
    processingFile,
  } = useConfirmFile(props);
  const {hideMedialModal} = props;
  const blobUrl = useMemo(() => {
    if (pickerFile && !pickerFile.base64 && Platform.OS === 'web')
      return URL.createObjectURL(pickerFile as Blob);
    return (pickerFile?.uri || pickerFileMeta?.url)?.replace(
      'file://',
      '',
    );
  }, [pickerFile?.size, pickerFile?.name]);
  const {width, height} = useWindowDimensions();
  useMemo(() => {
    if (type?.search('image') > -1 && blobUrl) {
      Image.getSize(blobUrl, (width, height) => {
        let aspect = '16/9';
        if (height > width) aspect = '9/16';
        setVideoMeta({
          ...videoMeta,
          width,
          height,
          duration: defaultVideoDuration,
          aspectRatio: aspect,
        });
      });
    }
  }, [pickerFile?.size, pickerFile?.name, type, blobUrl]);
  console.info(
    'isImageType',
    isImageType,
    pickerFile,
    pickerFileMeta,
  );
  const fontSize = 12;
  const inputWidth = 120;
  const [outputMenuVisible, setOutputMenuVisible] = useState(false);
  const [presetMenuVisible, setPresetMenuVisible] = useState(false);
  const closeMenu = () => {
    setOutputMenuVisible(false);
    setPresetMenuVisible(false);
  };
  const outputTypes = ['LOW', 'SD', 'HD'];
  const aspecRatios = ['16/9', '9/16'];
  return (
    <View style={{height: 'auto', width: '100%'}}>
      <Banner
        theme={theme}
        visible={processingFile}
        style={{width: '100%', margin: 0, padding: 0}}>
        <Card
          style={{
            borderBlockColor: 'transparent',
            borderRadius: 0,
            borderColor: 'transparent',
            width: '100%',
            borderWidth: 0,
            shadowColor: 'transparent',
          }}>
          <Card.Title
            style={{width: '100%'}}
            titleStyle={{fontSize: 20}}
            title="Processing file"
            subtitle={pickerFileMeta?.filename}
            left={props => <Avatar.Icon {...props} icon="file" />}
          />
          <ProgressBar indeterminate visible={true} />
        </Card>
      </Banner>
      <Portal>
        <Modal
          visible={mediaModalVisible && !processingFile}
          onDismiss={hideMedialModal}
          theme={theme}
          style={{
            padding: 20,
            width: width,
            height,
          }}>
          <Card style={{height}}>
            <Card.Title
              titleStyle={{fontSize: 20}}
              title={
                isEditorProject
                  ? 'Creating a New Project '
                  : 'Adding a new file'
              }
              subtitle="Please confirm"
              left={props => <Avatar.Icon {...props} icon="file" />}
            />
            <Divider />
            <GestureHandlerRootView style={{height: '70%'}}>
              <ScrollView>
                <Card.Content>
                  {isVideoType && (
                    <>
                      {Platform.OS === 'web' ? (
                        <video
                          style={{
                            display: 'flex',
                            width: '50%',
                            position: 'relative',
                            height: '100%',
                          }}
                          controls
                          src={blobUrl}
                          onLoadedMetadata={e => {
                            setVideoMeta({
                              ...videoMeta,
                              width: (e.nativeEvent.target as any)
                                ?.videoWidth,
                              height: (e.nativeEvent.target as any)
                                ?.videoHeight,
                              duration: (e.nativeEvent.target as any)
                                ?.duration,
                            });
                          }}
                        />
                      ) : (
                        <Video
                          style={{
                            display: 'flex',
                            width: '100%',
                            position: 'relative',
                            height: 200,
                          }}
                          useNativeControls={true}
                          source={{
                            uri:
                              'file://' +
                              pickerFileMeta?.url.replace(
                                'file://',
                                '',
                              ),
                          }}
                          onLoad={e => {
                            console.info('onload', e);
                            setVideoMeta({
                              ...videoMeta,
                              duration:
                                ((e as AVPlaybackStatusSuccess)
                                  ?.durationMillis || 0) / 1000,
                            });
                          }}
                          onReadyForDisplay={e => {
                            console.info('onready for display', e);
                            setVideoMeta({
                              ...videoMeta,
                              width: e.naturalSize.width,
                              height: e.naturalSize.height,
                              aspectRatio:
                                e.naturalSize.orientation ===
                                'landscape'
                                  ? '16/9'
                                  : '9/16',
                              duration:
                                ((e.status as AVPlaybackStatusSuccess)
                                  ?.durationMillis || 0) / 1000,
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                  {isImageType === true ? (
                    <ImageBackground
                      style={{
                        height: 200,
                        width: '100%',
                        position: 'relative',
                        display: 'flex',
                      }}
                      resizeMethod="scale"
                      imageStyle={{resizeMode: 'contain'}}
                      // imageStyle={{width: '100%', height: '100%'}}
                      source={{
                        uri: Platform.select({
                          web: blobUrl,
                          native:
                            'file://' +
                            blobUrl.replace('file://', ''),
                        }),
                      }}
                    />
                  ) : null}

                  {isEditorProject && (
                    <List.Section>
                      <Divider key={'divstart'} />
                      <List.Item title={'Video Project Settings'} />
                      <Divider key={'divtitle'} />
                      <List.Item
                        key={'aspect'}
                        left={p => (
                          <List.Icon
                            {...p}
                            style={{fontSize}}
                            icon={'information'}
                          />
                        )}
                        titleStyle={{fontSize}}
                        title={'Title'}
                        // disabled={true}
                        onPress={() => {}}
                        description={p => (
                          <View style={{width: '100%'}}>
                            <TextInput
                              dense={true}
                              mode="outlined"
                              value={videoMeta.editorTitle}
                              style={{textAlign: 'right'}}
                              onChangeText={text => {
                                setVideoMeta({
                                  ...videoMeta,
                                  editorTitle: text,
                                });
                              }}
                            />
                          </View>
                        )}
                      />
                      <Divider key={'divaspect'} />
                      <List.Item
                        key={'aspect'}
                        left={p => (
                          <List.Icon
                            {...p}
                            style={{fontSize}}
                            icon={'aspect-ratio'}
                          />
                        )}
                        title={'Aspect Ratio'}
                        titleStyle={{fontSize}}
                        right={p => (
                          <View style={{width: inputWidth}}>
                            <Menu
                              visible={presetMenuVisible}
                              onDismiss={closeMenu}
                              anchor={
                                <Button
                                  mode="outlined"
                                  onPress={() =>
                                    setPresetMenuVisible(true)
                                  }>
                                  {`${
                                    videoMeta?.aspectRatio || '16/9'
                                  }`}
                                </Button>
                              }>
                              <>
                                {aspecRatios.map(item => (
                                  <Menu.Item
                                    key={item}
                                    onPress={() => {
                                      setVideoMeta({
                                        ...videoMeta,
                                        aspectRatio: item,
                                      });
                                      closeMenu();
                                    }}
                                    title={item}
                                  />
                                ))}
                              </>
                            </Menu>
                          </View>
                        )}
                      />
                      <Divider key={'divquality2'} />
                      <List.Item
                        key={'resolution'}
                        left={p => (
                          <List.Icon
                            {...p}
                            style={{fontSize}}
                            icon={'file-export'}
                          />
                        )}
                        title={'Output Quality'}
                        titleStyle={{fontSize}}
                        right={p => (
                          <View style={{width: inputWidth}}>
                            <Menu
                              visible={outputMenuVisible}
                              onDismiss={closeMenu}
                              anchor={
                                <Button
                                  mode="outlined"
                                  onPress={() =>
                                    setOutputMenuVisible(true)
                                  }>
                                  {`${videoMeta?.quality || 'HD'}`}
                                </Button>
                              }>
                              <>
                                {outputTypes.map(item => (
                                  <Menu.Item
                                    key={item}
                                    onPress={() => {
                                      setVideoMeta({
                                        ...videoMeta,
                                        quality: item,
                                      });
                                      closeMenu();
                                    }}
                                    title={item}
                                  />
                                ))}
                              </>
                            </Menu>
                          </View>
                        )}
                      />
                      <Divider key={'divquality'} />
                    </List.Section>
                  )}
                  <List.Section>
                    <List.Item
                      title={'Filename'}
                      description={pickerFileMeta?.filename}
                    />
                    <List.Item
                      title={'Format'}
                      description={pickerFileMeta?.type}
                    />
                    <List.Item
                      title={'Duration'}
                      description={videoMeta?.duration}
                    />
                    <List.Item
                      title={'Width'}
                      description={videoMeta?.width}
                    />
                    <List.Item
                      title={'Height'}
                      description={videoMeta?.height}
                    />
                    <List.Item
                      title={'Aspect Ratio'}
                      description={videoMeta?.aspectRatio}
                    />
                    <List.Item
                      title={'Size'}
                      description={niceBytes(
                        pickerFileMeta?.size?.toString() as string,
                      )}
                    />

                    <List.Item
                      title={'FolderId'}
                      description={pickerFileMeta?.folderId}
                    />

                    {/* <List.Item
                      onPress={() =>
                        dispatch(setUploadToCloud(!uploadToCloud))
                      }
                      title={'Upload To Cloud'}
                      right={props => (
                        <Switch theme={theme} value={uploadToCloud} />
                      )}
                    />
                    <List.Item
                      onPress={() =>
                        dispatch(setEncrypt(!encryptionEnabled))
                      }
                      title={'Encrypt'}
                      right={props => (
                        <Switch
                          theme={theme}
                          value={encryptionEnabled}
                        />
                      )}
                    /> */}
                  </List.Section>
                </Card.Content>
              </ScrollView>
            </GestureHandlerRootView>
            <Divider />
            <Card.Actions style={{height: 'auto'}}>
              <Button disabled={loading} onPress={hideMedialModal}>
                Cancel
              </Button>
              <Button loading={loading} onPress={confirmFile}>
                {loading ? 'Processing' : 'Confirm'}
              </Button>
            </Card.Actions>
          </Card>
        </Modal>
      </Portal>
    </View>
  );
}
